var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0093,
    cy: 16.7308,
    r: 15.6586,
    fill: "#FDA900",
    stroke: "#FDA900",
    strokeWidth: 1.84218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8587 22.2549C25.1044 22.7464 24.9051 23.3439 24.4137 23.5896C24.2708 23.6609 24.1189 23.6944 23.9697 23.6944C23.6043 23.695 23.2531 23.4934 23.0787 23.1446C23.0094 23.0087 21.2729 19.7153 17.0053 19.7153C12.7377 19.7153 11.0011 23.0087 10.9291 23.1489C10.6795 23.636 10.0832 23.8313 9.59349 23.585C9.10505 23.3379 8.90709 22.7444 9.1518 22.2546C9.24465 22.0696 11.4799 17.7257 17.0053 17.7257C22.5306 17.7257 24.7659 22.0696 24.8587 22.2549Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8225 13.507C12.967 13.507 13.8949 12.5791 13.8949 11.4345C13.8949 10.2899 12.967 9.36206 11.8225 9.36206C10.6779 9.36206 9.75 10.2899 9.75 11.4345C9.75 12.5791 10.6779 13.507 11.8225 13.507Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1896 13.507C23.3342 13.507 24.2621 12.5791 24.2621 11.4345C24.2621 10.2899 23.3342 9.36206 22.1896 9.36206C21.0451 9.36206 20.1172 10.2899 20.1172 11.4345C20.1172 12.5791 21.0451 13.507 22.1896 13.507Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoorDark);
export default __webpack_public_path__ + "static/media/poorDark.16457845fe312e1336c5ce7bf9f7546e.svg";
export { ForwardRef as ReactComponent };